var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVineMobileComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11a11 11 0 0 1-4.565-.99c-1.006-.459-4.075 1.84-5.378.45-1.303-1.388.82-4.17.2-5.349A10.95 10.95 0 0 1 0 11C0 4.925 4.925 0 11 0m0 2a9 9 0 0 0-7.474 14.016c.007 1.306-1.255 3.68-1.041 3.839s1.968-1.5 3.553-1.345A9 9 0 1 0 11 2m3.003 12c.511 0 .933.383.99.883L15 15c0 .552-.453 1-.997 1H7.997A.996.996 0 0 1 7 15c0-.552.453-1 .997-1zm1.995-4c.514 0 .937.383.995.883L17 11c0 .552-.456 1-1.002 1H6.002a.999.999 0 1 1 0-2zm-1.995-4c.511 0 .933.383.99.883L15 7c0 .552-.453 1-.997 1H7.997A.996.996 0 0 1 7 7c0-.552.453-1 .997-1z"
})));
export default SvgVineMobileComment;